import { createClient } from "@supabase/supabase-js";
import { debugLog, isDebugOn } from "./debug";

function pickEnv(...keys: string[]) {
  // @ts-expect-error vite injects import.meta.env
  const env = (import.meta as any).env || {};
  for (const k of keys) {
    const v = env[k];
    if (typeof v === "string" && v.trim().length > 0) return v.trim();
  }
  return undefined;
}

const SUPABASE_URL =
  pickEnv("VITE_SUPABASE_URL", "VITE_SUPABASE_PROJECT_URL", "NEXT_PUBLIC_SUPABASE_URL") || "";
const SUPABASE_ANON_KEY =
  pickEnv("VITE_SUPABASE_ANON_KEY", "VITE_SUPABASE_PUBLIC_ANON_KEY", "NEXT_PUBLIC_SUPABASE_ANON_KEY") || "";

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // Fail fast with a clear message in console for easier debugging
  // Do not throw synchronously to avoid breaking static routes; consumers hitting supabase will still fail clearly.
  console.error(
    "Missing Supabase env: expected VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (fallbacks checked: VITE_SUPABASE_PROJECT_URL/NEXT_PUBLIC_*).",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { auth: { persistSession: true } });

// Debug instrumentation (only when debug=1)
if (isDebugOn) {
  try {
    supabase.auth.onAuthStateChange((event, session) => {
      debugLog({ url: "[supabase:auth]", method: event, status: session ? 200 : 401 });
    });
    const origChannel = (supabase as any).channel?.bind(supabase);
    if (origChannel) {
      (supabase as any).channel = (...args: any[]) => {
        const ch = origChannel(...args);
        const key = String(args?.[0] ?? "");
        const origSubscribe = ch.subscribe?.bind(ch);
        if (origSubscribe) {
          ch.subscribe = (...sargs: any[]) => {
            debugLog({ url: `[supabase:rt:${key}]`, method: "SUBSCRIBE" });
            return origSubscribe(...sargs);
          };
        }
        const origUnsub = ch.unsubscribe?.bind(ch);
        if (origUnsub) {
          ch.unsubscribe = () => {
            debugLog({ url: `[supabase:rt:${key}]`, method: "UNSUBSCRIBE" });
            return origUnsub();
          };
        }
        return ch;
      };
    }
  } catch {
    // ignore debug wiring errors
  }
}
